import { useLanguage } from '../i18n';
import { WHATSAPP_URL } from '../lib/whatsapp';
import { WhatsAppIcon } from './WhatsAppIcon';

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  return (
    <a
      href={WHATSAPP_URL(t.whatsappMessage)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-graphite-200 text-silver shadow-lg shadow-black/40 transition-all duration-200 hover:-translate-y-0.5 hover:bg-graphite-200"
    >
      <WhatsAppIcon size={22} />
    </a>
  );
};
